import React, { Component,Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBTableBody,MDBTable, MDBTableHead, MDBAlert, MDBSelect , MDBInput,MDBRow, MDBCol, MDBIcon   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Divider   } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import domtoimage from 'dom-to-image';  
import { api, URL } from '../../api';


export default class Showmodulelist extends Component {
  selectRef = null;
    constructor(props) {
        super(props);
this.state = {
  modal: false,

  Curriculumopen_Full_Name_TH:'',
  emp:[],
  plan:[],

  Curriculumopen_ID:'',
  Course_YEAR:'',
  TEAM:'',
  week:'',
  title:'',
  ch:'',
  activity:'',
  teacherplanid:'',
  
  Univ_ID:'',
  Univ_NAME:'',

  Course:[],
}

//this.handleChange = this.handleChange.bind(this);


this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.onChange = this.onChange.bind(this);
this.handleChangeweek = this.handleChangeweek.bind(this);
this.handleChangetitle = this.handleChangetitle.bind(this);
this.handleChangech = this.handleChangech.bind(this);
this.handleChangeactivity = this.handleChangeactivity.bind(this);
this.getplan = this.getplan.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    Course_ID:this.props.Course_ID
    
  });
 // this.props.getclassroom();
}

onChange(value) {
    //  console.log(`selected ${value}`);
    this.setState({ teacherplanid:value})
 }


 componentDidMount() {

  //const { id_send } = this.props.id_send
  //console.log(id_send);
   this.setState({ Course_ID:this.props.Course_ID})
//   this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH})
//   this.setState({ Course_YEAR:this.props.Course_YEAR})
//   this.setState({ TEAM:this.props.Curriculumopen_TEAM})
//   this.setState({ Univ_ID:this.props.Univ_ID})
//   this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
  //this.setState({ Curriculumopen_User_UPDATE:localStorage.getItem('type2')})

  api.get('index/showshortcoursemd/'+this.props.Course_ID,
  //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
    //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
            {headers: {
            // Authorization: 'Bearer ' + localStorage.getItem('myData')
            }
            })
            //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
            .then(res => {
            // console.log(res.data[0].id)
            //  console.log(res.data)
          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
            //  console.log(Course)
               const Course = res.data;
                this.setState({ Course });
     }) 
     this.getplan();
  }


  handleChangeweek(event) {    this.setState({week: event.target.value});  }
  handleChangetitle(event) {    this.setState({title: event.target.value});  }
  handleChangech(event) {    this.setState({ch: event.target.value});  }
  handleChangeactivity(event) {    this.setState({activity: event.target.value});  }

  getplan() {
    setTimeout(() => {
       //ภายใน
       api.get('index/searchplan/'+this.props.Curriculumopen_ID)
       .then(res => {
       //  console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
       let sortplan = res.data.sort((a, b) => {
        return a.Plan_Week - b.Plan_Week;
      });
         this.setState({ plan: sortplan})
       }) 
     }, 0);
  }

  clearValue = () => {
    this.selectRef.select.clearValue();
  };


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
    if (this.state.teacherplanid !=='' ) {

                    setTimeout(() => {

                  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                  datafrm.append("Plan_Curriculumopen_ID", this.state.Curriculumopen_ID);
                  datafrm.append("Plan_Course_YEAR", this.state.Course_YEAR);
                  datafrm.append("Plan_Team", this.state.TEAM);
                  datafrm.append("Plan_Week", this.state.week);
                  datafrm.append("Plan_Title", this.state.title);
                  datafrm.append("Plan_Ch", this.state.ch);
                  datafrm.append("Plan_Activity", this.state.activity);
                  datafrm.append("Plan_Teacherplanid", this.state.teacherplanid);
                  datafrm.append("Univ_ID", this.state.Univ_ID);
                  
                  api.post("index/AddPlan/",datafrm,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                  })

              .then(res => {
                //    console.log(res);
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                              Swal.fire({
                                  title: 'บันทึกข้อมูลสำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {

                                  this.getplan();
                                  
                                })
                            }
                    })
                  //  this.toggle()
                  //  this.props.getclassroom()
                  this.setState({ teacherplanid: ''});
                  this.setState({ week: ''});
                  this.setState({ title: ''});
                  this.setState({ ch: ''});
                  this.setState({ activity: ''});
                  this.getplan();
            }, 1000);
    }else{
            Swal.fire({
              title: 'กรุณาเพิ่มผู้สอน',
              text: "และบันทึกอีกครั้ง",
              icon: 'warning',
            // showCancelButton: true,
              confirmButtonText: 'ตกลง',
            // cancelButtonText: 'No, keep it'
            }).then((result) => {
            
            })

    }

//window.location.href = '/creditbank/Curriculum'
//this.props.updateat();
//this.getExpert()
  }

    render() {
      //  console.log(this.state.Course_ID)
        //  console.log(this.state.Curriculumopen_ID)
        //  console.log(this.state.Course_YEAR)
        //  console.log(this.state.TEAM)
        //  console.log(this.state.week)
        //  console.log(this.state.title)
        //  console.log(this.state.ch)
        //  console.log(this.state.activity)
      //    console.log(this.state.teacherplanid)
        // console.log(this.state.Curriculumopen_Date_START)
        // console.log(this.state.Curriculumopen_Date_END)

      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
        
        return (
            <>
            {/* <MDBBtn onClick={this.toggle} color="deep-purple" size="sm">รายชื่อยังไม่ได้ฉีดวัคซีน</MDBBtn> */}
          

            <MDBContainer>
                            <h4 className="display-5 text-center">ตารางหลักสูตรระยะสั้น</h4>
                            <MDBTable small responsiveMd>
                                <MDBTableHead>
                                    <tr>
                                    <th>#</th>
                                    <th>ชื่อหลักสูตรระยะสั้น</th>
                                    <th>จำนวนชั่วโมง</th>
                                    <th>วันที่เริ่ม</th>
                                    <th>วันที่สิ้นสุด</th>
                                    <th>วันที่เพิ่มข้อมูล</th>
                                    <th>จัดการ</th>
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.Course.map((Course,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{Course.Shortcoursemd_Nameshort_TH}</td>
                                    <td>{Course.Shortcoursemd_Numch}</td>
                                    <td>{Course.Shortcoursemd_Timestart}</td>
                                    <td>{Course.Shortcoursemd_Timeend}</td>
                                    <td>{Course.Shortcoursemd_Dateadd}</td>
                                    <td></td>
                                   
                                    </tr>
                                   })}  
                                </MDBTableBody>
                            </MDBTable>   

                            </MDBContainer>


          </>
          
        )
    }
}
